import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Translate } from "../../translate";
import { getStore } from "../../utils/global";

const stats = [
  {
    key: 0,
    dataKey: "total",
    title: "All",
    icon: "check-circle",
    color: "green",
    href: "#/manage/0/0/0",
  },
  {
    key: 1,
    dataKey: "received",
    title: "Received",
    icon: "inbox",
    color: "orange",
    href: "#/manage/1/0/0",
  },
  {
    key: 2,
    dataKey: "archived",
    title: "Archived",
    icon: "archive",
    color: "#ed3755",
    href: "#/manage/2/0/0",
  },
  {
    key: 3,
    dataKey: "complete",
    title: "Completed",
    icon: "check-square",
    color: "#968fff",
    href: "#/manage/3/0/0",
  },
  {
    key: 4,
    dataKey: "rejected",
    title: "Rejected",
    icon: "window-close",
    color: "#8444F5",
    href: "#/manage/4/0/0",
  },
  {
    key: 5,
    dataKey: "sent",
    title: "Sent",
    icon: "paper-plane",
    color: "#39A2DB",
    href: "#/manage/5/0/0",
  },
  {
    key: 6,
    dataKey: "cancelled",
    title: "Canceled",
    icon: "ban",
    color: "#fc0328",
    href: "#/manage/6/0/0",
  },
  {
    key: 7,
    dataKey: "waiting",
    title: "Waiting",
    icon: "hourglass-half",
    color: "#f5a142",
    href: "#/manage/7/0/0",
  },
];

function Filter({ count, dataKey, activeFilter }) {
  let ln = typeof getStore("lang") === "object" ? "en" : getStore("lang");
  const data = stats.find((stat) => stat.dataKey === dataKey);
  return (
    <a
      href={data?.href}
      className="filter_container"
      disabled_link="1"
      boxsize={data?.size ? data?.size : ""}
      active={Number(activeFilter) === data?.key ? "1" : "0"}>
      <div className="filter_title">{Translate[ln].Manage.Filters[data?.title]}</div>
      <div className="filter_body">
        <div className="filter_icon">
          <FontAwesomeIcon icon={["fas", data?.icon]} style={{ color: data?.color }} />
        </div>
        <div className="filter_data">{count}</div>
      </div>
    </a>
  );
}

export default Filter;
